<template>
  <vue-aos animation-class="fadeInUp animated" style="animation-duration: 0.4s">
    <div class="talk" :class="{'right': right}">
      <div class="talk__wrapper" v-if="npc !== null">
        <div class="npc-info">
          <div class="talk-npc-img">
            <div class="talk-npc-img__wrapper">
              <img :src="npc.pic" />
            </div>
          </div>
          <!-- <div class="talk-npc-name">
            <label>{{npc.name}}</label>
          </div> -->
        </div>
        <div class="talk-npc-content">
          <div class="talk-npc-content_wrapper">
            <div class="talk-npc-content-name">
              <label>{{npc.name}}</label>
            </div>
            <p>
              <slot></slot>
            </p>
          </div>
        </div>
      </div>
    </div>
  </vue-aos>
</template>

<script>
export default {
  name: 'npc',
  props: {
    npcId: Number,
    right: Boolean,
  },
  data() {
    return {
      npcs: [
        {
          id: 0,
          name: '呂善安',
          pic: require('@/assets/images/profile_pic/NPC1.png'),
        },
        {
          id: 1,
          name: '蘇博思',
          pic: require('@/assets/images/profile_pic/NPC2.png'),
        },
        {
          id: 2,
          name: '館員',
          pic: require('@/assets/images/profile_pic/NPC_NO_ONE.png'),
        },
        {
          id: 3,
          name: '時空警察',
          pic: require('@/assets/images/profile_pic/NPC3.png'),
        },
        {
          id: 4,
          name: '怪盜',
          pic: require('@/assets/images/profile_pic/NPC4.png'),
        },
        {
          id: 5,
          name: '館員',
          pic: require('@/assets/images/profile_pic/NPC_NO_ONE.png'),
        },
      ],
    };
  },
  computed: {
    npc() {
      const n = this.npcs.filter(item => {
        return item.id === this.npcId;
      });
      if (n.length === 1) {
        return n[0];
      }
      return null;
    }
  }
}
</script>

<style scoped>
.talk {
  margin-bottom: 2rem;
}

.talk .talk__wrapper {
  display: flex;
  flex-wrap: nowrap;
}

.npc-info {
  position: relative;
  flex: 0 0 25%;
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  z-index: 2;
}

.talk-npc-img {
  position: relative;
  width: 100%;
  /* border: solid 4px #b78e32; */
  border-radius: 50%;
  overflow: hidden;
  background-color: #e7e9dc;
  box-shadow: 0 0 2px 2px #b78e32;
}

.talk-npc-img .talk-npc-img__wrapper {
  position: relative;
  padding-top: 100%;
}

.talk-npc-img .talk-npc-img__wrapper>img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;

}

.talk-npc-name {
  position: relative;
  width: 100%;
  margin-top: -10px;
}

.talk-npc-name>label {
  width: 100%;
  text-align: center;
  background-color: #e7e9dc;
  border-radius: 1rem;
  border: solid 2px #b78e32;
  color: #333;
  font-weight: 1000;
}

.talk-npc-content {
  flex: 1 1;
  padding-top: 3rem;
  position: relative;
  z-index: 1;
}

.talk-npc-content .talk-npc-content_wrapper {
  position: relative;
  color: #000;
  background-color: #fffd;
  padding-top: .8rem;
  padding-bottom: .8rem;
  padding-left: 3rem;
  padding-right: 1.5rem;
  border-radius: 0.2rem;
  /* border: solid 2px #b78e32; */
  width: fit-content;
  margin-right: auto;
  max-width: 100%;
  text-align: justify;

  transform: translate(-2rem, 0);

  line-height: 1.5em;
  letter-spacing: .07em;
  box-shadow: 2px 2px 2px 2px #ddd4;
}

.talk-npc-content .talk-npc-content_wrapper>.talk-npc-content-name {
  position: absolute;
  margin-top: 0;
  top: 0;
  transform: translate(0, -80%);
  background-color: #b78e32;
  color: #fffd;
  padding: .2rem .8rem;
  border-radius: 999rem;
}

.talk:not(.right) .talk-npc-content .talk-npc-content_wrapper>.talk-npc-content-name {
  left: 0;
  padding-left: 3rem;
}

.talk-npc-content .talk-npc-content_wrapper>.talk-npc-content-name>label {
  font-size: .8em;
  margin: 0;
  font-weight: 1000;
}

.talk-npc-content .talk-npc-content_wrapper>p {
  margin-bottom: 0;
}

.talk.right .talk__wrapper {
  flex-direction: row-reverse;
}

.talk.right .talk-npc-img .talk-npc-img__wrapper>img {
  transform: rotateY(180deg);
}

.talk.right .talk-npc-content .talk-npc-content_wrapper {
  padding-left: 1.5rem;
  padding-right: 3rem;
  transform: translate(2rem, 0);
  margin-right: 0;
  margin-left: auto;
}

.talk.right .talk-npc-content .talk-npc-content_wrapper>.talk-npc-content-name {
  padding-right: 3rem;
  right: 0;
}


@media (min-width: 768px){
  .npc-info {
    flex: 0 0 20%;
    width: 20%;
  }

  .talk-npc-name>label {
    font-size: 1.2rem;
  }
}
</style>
